const HOURS = Array.from({ length: 24 }, (_, h) => String(h).padStart(2, "0"));
const QUARTERS = ["00", "15", "30", "45"];

/**
 * A time as an hour and a minute dropdown, the minutes in quarter hours. A time already saved on another
 * minute (from the punch clock, say) keeps it as an extra choice, so it can be saved unchanged.
 * `value` is "HH:MM", or "" for no time (allowed unless `required`).
 */
export function TimeSelect({
  id,
  value,
  onChange,
  required = false,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}) {
  const [h, m] = value ? value.split(":") : ["", ""];
  const minutes = m && !QUARTERS.includes(m) ? [...QUARTERS, m].sort() : QUARTERS;
  return (
    <span className="time-select">
      <select
        id={id}
        required={required}
        value={h}
        onChange={(e) => onChange(e.target.value ? `${e.target.value}:${m || "00"}` : "")}
      >
        <option value="">{required ? "Hour" : "–"}</option>
        {HOURS.map((x) => (
          <option key={x} value={x}>
            {x}
          </option>
        ))}
      </select>
      <span aria-hidden="true">:</span>
      <select
        aria-label="Minutes"
        value={m || "00"}
        disabled={!h}
        onChange={(e) => onChange(`${h}:${e.target.value}`)}
      >
        {minutes.map((x) => (
          <option key={x} value={x}>
            {x}
          </option>
        ))}
      </select>
    </span>
  );
}
